module.exports = __webpack_public_path__ + "img/loginLogo1.76697a3c.png";